import DragonbonesComponent from '../Component/Dragonbones';
import dragonBones from 'pixi-dragonbones';
import PIXIRenderer from '../System/Render/PIXIRenderer';
import Game from '../Game';
import AnimationComponent from '../Component/Animation';
import TransformComponent from '../Component/Transform';
import GameObject from '../GameObject/GameObject';
import Renderable from '../Component/Renderable';
import RelativePositionComponent from '../Component/Render/RelativePosition';
import { report } from '../report';

export default class Armature extends GameObject<dragonBones.PixiArmatureDisplay> {
    public container: dragonBones.PixiArmatureDisplay;

    protected instantiateContainer(params: {
        dragonbonesName: string;
        armatureName: string;
    }): void {
        this.setArmatureData(params);
    }

    protected onCreate(params: Partial<DragonbonesComponent>): void {
        this.addComponent(Renderable, params);
        this.addComponent(TransformComponent, params);
        this.addComponent(DragonbonesComponent, params);
        this.addComponent(AnimationComponent, params);
        if (params.relativePosition) {
            this.addComponent(RelativePositionComponent, params);
        }
    }

    public setArmatureData(params: {
        dragonbonesName: string;
        armatureName: string;
    }): void {
        // Make sure dragonbones data (skeleton & animations) is available
        const dbDataCacheKey = params.dragonbonesName;
        if (!PIXIRenderer.dbFactory.getDragonBonesData(dbDataCacheKey)) {
            const dbDataRaw = Game.resource.get<unknown>(
                `${params.dragonbonesName}_skeleton_data`
            );
            verifyDBName(
                'dragonbones data',
                dbDataCacheKey,
                (dbDataRaw as any)?.name
            );
            PIXIRenderer.dbFactory.parseDragonBonesData(
                dbDataRaw,
                dbDataCacheKey
            );
        }

        // Make sure atlas & texture data are available

        const dbTextureAtlasCacheKey = dbDataCacheKey;
        if (
            !PIXIRenderer.dbFactory.getTextureAtlasData(dbTextureAtlasCacheKey)
        ) {
            const dbTextureAtlasRaw = Game.resource.get<unknown>(
                `${params.dragonbonesName}_texture_data`
            );
            verifyDBName(
                'texture atlas data',
                dbTextureAtlasCacheKey,
                (dbTextureAtlasRaw as any)?.name
            );
            PIXIRenderer.dbFactory.parseTextureAtlasData(
                dbTextureAtlasRaw,
                Game.resource.get<unknown>(`${params.dragonbonesName}_texture`),
                dbTextureAtlasCacheKey
            );
        }

        //
        this.container?.destroy();
        const container = PIXIRenderer.dbFactory.buildArmatureDisplay(
            params.armatureName,
            dbDataCacheKey,
            undefined,
            dbTextureAtlasCacheKey
        );
        this.setContainer(container)
        this.getComponent(DragonbonesComponent)?.update({ dragonbonesName: params.dragonbonesName, armatureName: params.armatureName });
    }

    set timeScale(value: number) {
        this.container.animation.timeScale = value;
    }

    get timeScale(): number {
        return this.container.animation.timeScale;
    }
}

function verifyDBName(
    context: string,
    expectedName: string,
    actualName: unknown
) {
    if (actualName === expectedName) return;
    report(`verifyDBName failed for ${context}`, {
        once: true,
        sampleRate: 0.1,
        tags: {
            expectedName,
            actualName: String(actualName),
        },
        fingerprint: `verifyDBName ${context}`,
    });
}
